import { PageId } from 'constants/pages'

export const enum PageIdIntl1 {
  ANALYZING = PageId.ANALYZING,
  START = PageId.START,
  QUESTION_1 = PageId.QUESTION_1,
  QUESTION_2 = PageId.QUESTION_2,
  QUESTION_3 = PageId.QUESTION_3,
  QUESTION_4 = PageId.QUESTION_4,
  SPEED_FEEDBACK = PageId.SPEED_FEEDBACK,
  QUESTION_5 = PageId.QUESTION_5,
  QUESTION_6 = PageId.QUESTION_6,
  QUESTION_7 = PageId.QUESTION_7,
  QUESTION_8 = PageId.QUESTION_8,
  QUESTION_9 = PageId.QUESTION_9,
  QUESTION_10 = PageId.QUESTION_10,
  QUESTION_11 = PageId.QUESTION_11,
  QUESTION_12 = PageId.QUESTION_12,
  SMARTNESS_FEEDBACK = PageId.SMARTNESS_FEEDBACK,
  QUESTION_13 = PageId.QUESTION_13,
  QUESTION_14 = PageId.QUESTION_14,
  QUESTION_15 = PageId.QUESTION_15,
  QUESTION_16 = PageId.QUESTION_16,
  QUESTION_17 = PageId.QUESTION_17,
  QUESTION_18 = PageId.QUESTION_18,
  QUESTION_19 = PageId.QUESTION_19,
  QUESTION_20 = PageId.QUESTION_20,
  LOGICAL_SKILLS_FEEDBACK = PageId.LOGICAL_SKILLS_FEEDBACK,
  QUESTION_21 = PageId.QUESTION_21,
  QUESTION_22 = PageId.QUESTION_22,
  QUESTION_23 = PageId.QUESTION_23,
  QUESTION_24 = PageId.QUESTION_24,
  QUESTION_25 = PageId.QUESTION_25,
  AGE_QUESTION = PageId.AGE_QUESTION,
  EDUCATION_QUESTION = PageId.EDUCATION_QUESTION,
  DISCOVER_FEEDBACKS = PageId.DISCOVER_FEEDBACKS,
  PREPARE_FLOW = PageId.PREPARE_FLOW,
  EMAIL = PageId.EMAIL,
  OFFER = PageId.OFFER,
  PAYMENT = PageId.PAYMENT,
  REGISTRATION = PageId.REGISTRATION,
  NAME_ENTRY = PageId.NAME_ENTRY,
  CERTIFICATE = PageId.CERTIFICATE,
  REPORT = PageId.REPORT,
}
